import Link from 'next/link';
import { useRouter } from 'next/router';
import { removeDefaultParams } from '../../../Utils/helper';
import {
  clickCardEvent,
  fireClickedCta,
} from '../../../Utils/StoreHomePageUtils';
import { AddToCartButtonFilled } from '../../StoreCategoryPage/SubCategoryProducts/styled';
import BannersGridImage from '../BannersGrid/BannersGridImage';
import { GridBoxTitle } from '../BannersGrid/styled';
import { CardContent, CarouselCardBox } from './WaveCarousel.styled';

export default function WaveCarouselCard(props) {
  const {
    parentIndex,
    banner,
    type,
    element,
    index,
    sectionName,
    length,
    sectionHeading,
  } = props;

  const router = useRouter();
  // const [userTypeCheck, setUserTypeCheck] = useState(null);
  const onBannerClick = (value, itemName) => {
    let category_id = value?.deeplinkValue.split('_')[1];
    // let copy_data = JSON.parse(JSON.stringify(value));
    // if (getWebUserType() === "B" && banner.headingAlignment === "WAVE") {
    //     copy_data.itemType = "insta_video";
    // }
    clickCardEvent(value, category_id, type, itemName, {
      heading: banner?.heading || banner?.itemName,
      itemId: banner?.itemId,
      position: index,
      // instaUrl: getWebUserType() === "B" ? element?.instaVideo : null,
    });
  };

  // useEffect(() => {
  //     setUserTypeCheck(getWebUserType());
  // }, [element]);

  return (
    <CarouselCardBox
      className="column_direction"
      key={index}
      id={
        index == 0
          ? `${sectionName}first`
          : index == length - 1
            ? `${sectionName}last`
            : `testimonial${index}`
      }
      onClick={() => {
        onBannerClick(element, element?.itemName);
      }}
    >
      {/* {userTypeCheck === "A" ? ( */}
      <BannersGridImage
        parentIndex={parentIndex}
        element={element}
        onBannerClick={onBannerClick}
        banner={banner}
        sectionHeading={sectionHeading}
      />
      {/* ) : (
            <>
                <InstaVideoCard
                    element={element}
                    onBannerClick={onBannerClick}
                />
                <InstaUserSection>
                    <Image
                        src={element?.instaImage}
                        alt="user image"
                        width={32}
                        height={32}
                        layout="fixed"
                    />
                    <Followers>
                        <InstaUsername> {element?.instaName}</InstaUsername>
                        <InstaFollower>
                            <Image
                                src="https://images.myloapp.in/NestJsUploads/1668758577589-insta.svg"
                                layout="fixed"
                                width={16}
                                height={16}
                                className="instaImage"
                                alt="insta icon"
                            />{" "}
                            {element?.instaFollower}
                        </InstaFollower>
                    </Followers>
                </InstaUserSection>
            </>{" "}
            {/* )} */}
      {/* <InstaVideoCard element={element} onBannerClick={onBannerClick} /> */}
      {element?.heading && <GridBoxTitle>{element.heading}</GridBoxTitle>}
      {element?.subHeading && <CardContent>{element.subHeading}</CardContent>}
      {element?.showCta ? (
        <Link
          href={{
            pathname: element?.deeplinkValue,
            query: removeDefaultParams(router.query),
          }}
          passHref
          locale={false}
          legacyBehavior
        >
          <AddToCartButtonFilled
            listTemplate
            as="a"
            className="add_btn_filled"
            onClick={() => fireClickedCta(element, banner)}
          >
            {element.ctaText}
          </AddToCartButtonFilled>
        </Link>
      ) : null}
    </CarouselCardBox>
  );
}
